import { render } from "./PlainText.vue?vue&type=template&id=4195cd12&scoped=true&lang=pug"
import script from "./PlainText.vue?vue&type=script&lang=js"
export * from "./PlainText.vue?vue&type=script&lang=js"

import "./PlainText.vue?vue&type=style&index=0&id=4195cd12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4195cd12"]])

export default __exports__